/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationSettingsDto } from '../../models/application-settings-dto';

export interface GetSettings$Params {
}

export function getSettings(http: HttpClient, rootUrl: string, params?: GetSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettingsDto>> {
  const rb = new RequestBuilder(rootUrl, getSettings.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApplicationSettingsDto>;
    })
  );
}

getSettings.PATH = '/api/application/settings';
